import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=69860232&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=ts"
export * from "./Preferences.vue?vue&type=script&lang=ts"
import style0 from "./Preferences.vue?vue&type=style&index=0&id=69860232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69860232",
  null
  
)

export default component.exports